import { React, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { USER_LOGIN_REDIRECT } from '../../utils/constants'
import PermissionsIssue from '../NoAccess/PermissionsIssue'
import PageNotFound from '../PageNotFound'
import Container from '../Container'
import Layout from '../Layout'

import { useAuthState } from './'

const requiresAuth =
  (
    Component,
    {
      roles = ['Basic', 'Power User', 'Admin'],
      env = ['local', 'dev', 'stage', 'prod'],
      key,
    } = {}
  ) =>
  (props) => {
    const location = useLocation()
    const history = useHistory()
    const { isAuthenticated, user } = useAuthState()
    
    useEffect(() => {
      if (!isAuthenticated) {
        window.localStorage.setItem(
          USER_LOGIN_REDIRECT,
          JSON.stringify({ location })
        )

        history.push('/')
      }
    }, [])

    if (isAuthenticated) {
      const isAuthorized = roles.includes(user.role)
      debugger
      const access = user?.usercomponents.includes(key.toLowerCase())
      const isAllowedInEnv = env.includes(
        process.env.REACT_APP_ENV.toLowerCase()
      )
      if (isAuthorized && isAllowedInEnv) {
        if (!access) {
          return <PermissionsIssue />
        }
        return <Component {...props} />
      }
      return (
        <Layout>
          <Container>
            <PageNotFound />
          </Container>
        </Layout>
      )
    }

    return null
  }

export default requiresAuth
